import PropTypes from 'prop-types';
import React from 'react';

import {INPUT_USER} from '../../constants/inputs';
import './InputUser.style.scss';

export const InputUser = (props) => {
  const Component = INPUT_USER[props.valueType] || INPUT_USER.default;
  return <Component props={props} />;
};

InputUser.propTypes = {
  valueType: PropTypes.string
};
